"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require("bluebird");

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _languageHandler = require("../../../../../languageHandler");

var _SettingsStore = require("../../../../../settings/SettingsStore");

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _LabelledToggleSwitch = require("../../../elements/LabelledToggleSwitch");

var _LabelledToggleSwitch2 = _interopRequireDefault(_LabelledToggleSwitch);

var _Field = require("../../../elements/Field");

var _Field2 = _interopRequireDefault(_Field);

var _ = require("../../../../..");

var _2 = _interopRequireDefault(_);

var _PlatformPeg = require("../../../../../PlatformPeg");

var _PlatformPeg2 = _interopRequireDefault(_PlatformPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd
Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var PreferencesUserSettingsTab = function (_React$Component) {
    (0, _inherits3.default)(PreferencesUserSettingsTab, _React$Component);

    function PreferencesUserSettingsTab() {
        (0, _classCallCheck3.default)(this, PreferencesUserSettingsTab);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PreferencesUserSettingsTab.__proto__ || (0, _getPrototypeOf2.default)(PreferencesUserSettingsTab)).call(this));

        _this._onAutoLaunchChange = function (checked) {
            _PlatformPeg2.default.get().setAutoLaunchEnabled(checked).then(function () {
                return _this.setState({ autoLaunch: checked });
            });
        };

        _this._onAlwaysShowMenuBarChange = function (checked) {
            _PlatformPeg2.default.get().setAutoHideMenuBarEnabled(!checked).then(function () {
                return _this.setState({ alwaysShowMenuBar: checked });
            });
        };

        _this._onMinimizeToTrayChange = function (checked) {
            _PlatformPeg2.default.get().setMinimizeToTrayEnabled(checked).then(function () {
                return _this.setState({ minimizeToTray: checked });
            });
        };

        _this._onAutocompleteDelayChange = function (e) {
            _this.setState({ autocompleteDelay: e.target.value });
            _SettingsStore2.default.setValue("autocompleteDelay", null, _SettingsStore.SettingLevel.DEVICE, e.target.value);
        };

        _this._onReadMarkerInViewThresholdMs = function (e) {
            _this.setState({ readMarkerInViewThresholdMs: e.target.value });
            _SettingsStore2.default.setValue("readMarkerInViewThresholdMs", null, _SettingsStore.SettingLevel.DEVICE, e.target.value);
        };

        _this._onReadMarkerOutOfViewThresholdMs = function (e) {
            _this.setState({ readMarkerOutOfViewThresholdMs: e.target.value });
            _SettingsStore2.default.setValue("readMarkerOutOfViewThresholdMs", null, _SettingsStore.SettingLevel.DEVICE, e.target.value);
        };

        _this.state = {
            autoLaunch: false,
            autoLaunchSupported: false,
            alwaysShowMenuBar: true,
            alwaysShowMenuBarSupported: false,
            minimizeToTray: true,
            minimizeToTraySupported: false,
            autocompleteDelay: _SettingsStore2.default.getValueAt(_SettingsStore.SettingLevel.DEVICE, 'autocompleteDelay').toString(10),
            readMarkerInViewThresholdMs: _SettingsStore2.default.getValueAt(_SettingsStore.SettingLevel.DEVICE, 'readMarkerInViewThresholdMs').toString(10),
            readMarkerOutOfViewThresholdMs: _SettingsStore2.default.getValueAt(_SettingsStore.SettingLevel.DEVICE, 'readMarkerOutOfViewThresholdMs').toString(10)
        };
        return _this;
    }

    (0, _createClass3.default)(PreferencesUserSettingsTab, [{
        key: "componentWillMount",
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var platform, autoLaunchSupported, autoLaunch, alwaysShowMenuBarSupported, alwaysShowMenuBar, minimizeToTraySupported, minimizeToTray;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                platform = _PlatformPeg2.default.get();
                                _context.next = 3;
                                return (0, _bluebird.resolve)(platform.supportsAutoLaunch());

                            case 3:
                                autoLaunchSupported = _context.sent;
                                autoLaunch = false;

                                if (!autoLaunchSupported) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 8;
                                return (0, _bluebird.resolve)(platform.getAutoLaunchEnabled());

                            case 8:
                                autoLaunch = _context.sent;

                            case 9:
                                _context.next = 11;
                                return (0, _bluebird.resolve)(platform.supportsAutoHideMenuBar());

                            case 11:
                                alwaysShowMenuBarSupported = _context.sent;
                                alwaysShowMenuBar = true;

                                if (!alwaysShowMenuBarSupported) {
                                    _context.next = 17;
                                    break;
                                }

                                _context.next = 16;
                                return (0, _bluebird.resolve)(platform.getAutoHideMenuBarEnabled());

                            case 16:
                                alwaysShowMenuBar = !_context.sent;

                            case 17:
                                _context.next = 19;
                                return (0, _bluebird.resolve)(platform.supportsMinimizeToTray());

                            case 19:
                                minimizeToTraySupported = _context.sent;
                                minimizeToTray = true;

                                if (!minimizeToTraySupported) {
                                    _context.next = 25;
                                    break;
                                }

                                _context.next = 24;
                                return (0, _bluebird.resolve)(platform.getMinimizeToTrayEnabled());

                            case 24:
                                minimizeToTray = _context.sent;

                            case 25:

                                this.setState({
                                    autoLaunch: autoLaunch,
                                    autoLaunchSupported: autoLaunchSupported,
                                    alwaysShowMenuBarSupported: alwaysShowMenuBarSupported,
                                    alwaysShowMenuBar: alwaysShowMenuBar,
                                    minimizeToTraySupported: minimizeToTraySupported,
                                    minimizeToTray: minimizeToTray
                                });

                            case 26:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentWillMount() {
                return _ref.apply(this, arguments);
            }

            return componentWillMount;
        }()
    }, {
        key: "_renderGroup",
        value: function _renderGroup(settingIds) {
            var SettingsFlag = _2.default.getComponent("views.elements.SettingsFlag");
            return settingIds.map(function (i) {
                return _react2.default.createElement(SettingsFlag, { key: i, name: i, level: _SettingsStore.SettingLevel.ACCOUNT });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var autoLaunchOption = null;
            if (this.state.autoLaunchSupported) {
                autoLaunchOption = _react2.default.createElement(_LabelledToggleSwitch2.default, {
                    value: this.state.autoLaunch,
                    onChange: this._onAutoLaunchChange,
                    label: (0, _languageHandler._t)('Start automatically after system login') });
            }

            var autoHideMenuOption = null;
            if (this.state.alwaysShowMenuBarSupported) {
                autoHideMenuOption = _react2.default.createElement(_LabelledToggleSwitch2.default, {
                    value: this.state.alwaysShowMenuBar,
                    onChange: this._onAlwaysShowMenuBarChange,
                    label: (0, _languageHandler._t)('Always show the window menu bar') });
            }

            var minimizeToTrayOption = null;
            if (this.state.minimizeToTraySupported) {
                minimizeToTrayOption = _react2.default.createElement(_LabelledToggleSwitch2.default, {
                    value: this.state.minimizeToTray,
                    onChange: this._onMinimizeToTrayChange,
                    label: (0, _languageHandler._t)('Show tray icon and minimize window to it on close') });
            }

            return _react2.default.createElement(
                "div",
                { className: "mx_SettingsTab mx_PreferencesUserSettingsTab" },
                _react2.default.createElement(
                    "div",
                    { className: "mx_SettingsTab_heading" },
                    (0, _languageHandler._t)("Preferences")
                ),
                _react2.default.createElement(
                    "div",
                    { className: "mx_SettingsTab_section" },
                    _react2.default.createElement(
                        "span",
                        { className: "mx_SettingsTab_subheading" },
                        (0, _languageHandler._t)("Composer")
                    ),
                    this._renderGroup(PreferencesUserSettingsTab.COMPOSER_SETTINGS),
                    _react2.default.createElement(
                        "span",
                        { className: "mx_SettingsTab_subheading" },
                        (0, _languageHandler._t)("Timeline")
                    ),
                    this._renderGroup(PreferencesUserSettingsTab.TIMELINE_SETTINGS),
                    _react2.default.createElement(
                        "span",
                        { className: "mx_SettingsTab_subheading" },
                        (0, _languageHandler._t)("Room list")
                    ),
                    this._renderGroup(PreferencesUserSettingsTab.ROOM_LIST_SETTINGS),
                    _react2.default.createElement(
                        "span",
                        { className: "mx_SettingsTab_subheading" },
                        (0, _languageHandler._t)("Advanced")
                    ),
                    this._renderGroup(PreferencesUserSettingsTab.ADVANCED_SETTINGS),
                    minimizeToTrayOption,
                    autoHideMenuOption,
                    autoLaunchOption,
                    _react2.default.createElement(_Field2.default, {
                        id: "autocompleteDelay",
                        label: (0, _languageHandler._t)('Autocomplete delay (ms)'),
                        type: "number",
                        value: this.state.autocompleteDelay,
                        onChange: this._onAutocompleteDelayChange }),
                    _react2.default.createElement(_Field2.default, {
                        id: "readMarkerInViewThresholdMs",
                        label: (0, _languageHandler._t)('Read Marker lifetime (ms)'),
                        type: "number",
                        value: this.state.readMarkerInViewThresholdMs,
                        onChange: this._onReadMarkerInViewThresholdMs }),
                    _react2.default.createElement(_Field2.default, {
                        id: "readMarkerOutOfViewThresholdMs",
                        label: (0, _languageHandler._t)('Read Marker off-screen lifetime (ms)'),
                        type: "number",
                        value: this.state.readMarkerOutOfViewThresholdMs,
                        onChange: this._onReadMarkerOutOfViewThresholdMs })
                )
            );
        }
    }]);
    return PreferencesUserSettingsTab;
}(_react2.default.Component);

PreferencesUserSettingsTab.COMPOSER_SETTINGS = ['useCiderComposer', 'MessageComposerInput.autoReplaceEmoji', 'MessageComposerInput.suggestEmoji', 'sendTypingNotifications'];
PreferencesUserSettingsTab.TIMELINE_SETTINGS = ['autoplayGifsAndVideos', 'urlPreviewsEnabled', 'TextualBody.enableBigEmoji', 'showReadReceipts', 'showTwelveHourTimestamps', 'alwaysShowTimestamps', 'showRedactions', 'enableSyntaxHighlightLanguageDetection', 'showJoinLeaves', 'showAvatarChanges', 'showDisplaynameChanges', 'showImages'];
PreferencesUserSettingsTab.ROOM_LIST_SETTINGS = ['RoomList.orderByImportance', 'breadcrumbs'];
PreferencesUserSettingsTab.ADVANCED_SETTINGS = ['alwaysShowEncryptionIcons', 'Pill.shouldShowPillAvatar', 'TagPanel.enableTagPanel', 'promptBeforeInviteUnknownUsers'];
exports.default = PreferencesUserSettingsTab;
module.exports = exports["default"];
//# sourceMappingURL=PreferencesUserSettingsTab.js.map